module.exports = __webpack_public_path__ + "63fc3549aa1ebfc94859725b0bf71aa8.jpg";